export default {"src":"/_next/static/media/gold.91b869bb.svg","height":103,"width":356,"blurWidth":0,"blurHeight":0};